export default "__VITE_ASSET__B_hRxs5s__"